var map = {
	"./AD.svg": 93968,
	"./AE.svg": 2189,
	"./AF.svg": 22201,
	"./AG.svg": 27911,
	"./AI.svg": 6808,
	"./AL.svg": 34698,
	"./AM.svg": 88363,
	"./AO.svg": 10239,
	"./AQ.svg": 29738,
	"./AR.svg": 40118,
	"./AS.svg": 52562,
	"./AT.svg": 96010,
	"./AU.svg": 23643,
	"./AW.svg": 98569,
	"./AX.svg": 10854,
	"./AZ.svg": 9407,
	"./BA.svg": 74652,
	"./BB.svg": 96267,
	"./BD.svg": 35637,
	"./BE.svg": 10309,
	"./BF.svg": 45004,
	"./BG.svg": 74225,
	"./BH.svg": 29388,
	"./BI.svg": 74348,
	"./BJ.svg": 39059,
	"./BL.svg": 60690,
	"./BM.svg": 79753,
	"./BN.svg": 45464,
	"./BO.svg": 66250,
	"./BQ.svg": 46133,
	"./BR.svg": 17988,
	"./BS.svg": 30545,
	"./BT.svg": 23981,
	"./BV.svg": 82504,
	"./BW.svg": 13864,
	"./BY.svg": 5887,
	"./BZ.svg": 43316,
	"./CA.svg": 88924,
	"./CC.svg": 80438,
	"./CD.svg": 65650,
	"./CF.svg": 30001,
	"./CG.svg": 47358,
	"./CH.svg": 27734,
	"./CI.svg": 4807,
	"./CK.svg": 9218,
	"./CL.svg": 35745,
	"./CM.svg": 61251,
	"./CN.svg": 82177,
	"./CO.svg": 56207,
	"./CR.svg": 43862,
	"./CU.svg": 54265,
	"./CV.svg": 97898,
	"./CW.svg": 75278,
	"./CX.svg": 36573,
	"./CY.svg": 78778,
	"./CZ.svg": 2273,
	"./DE.svg": 45300,
	"./DJ.svg": 52496,
	"./DK.svg": 10593,
	"./DM.svg": 13565,
	"./DO.svg": 88618,
	"./DZ.svg": 35493,
	"./EC.svg": 6628,
	"./EE.svg": 79888,
	"./EG.svg": 87059,
	"./EH.svg": 60431,
	"./ER.svg": 69282,
	"./ES.svg": 33348,
	"./ET.svg": 52628,
	"./EU.svg": 81803,
	"./FI.svg": 22672,
	"./FJ.svg": 33643,
	"./FK.svg": 41069,
	"./FM.svg": 84535,
	"./FO.svg": 22007,
	"./FR.svg": 48020,
	"./GA.svg": 95678,
	"./GB-ENG.svg": 78938,
	"./GB-NIR.svg": 93321,
	"./GB-SCT.svg": 63292,
	"./GB-WLS.svg": 30993,
	"./GB-ZET.svg": 76672,
	"./GB.svg": 89469,
	"./GD.svg": 22587,
	"./GE.svg": 83234,
	"./GF.svg": 77931,
	"./GG.svg": 54287,
	"./GH.svg": 60063,
	"./GI.svg": 6724,
	"./GL.svg": 2607,
	"./GM.svg": 82092,
	"./GN.svg": 54561,
	"./GP.svg": 42651,
	"./GQ.svg": 2615,
	"./GR.svg": 76216,
	"./GS.svg": 59748,
	"./GT.svg": 82618,
	"./GU.svg": 79040,
	"./GW.svg": 32708,
	"./GY.svg": 39678,
	"./HK.svg": 97391,
	"./HM.svg": 78909,
	"./HN.svg": 80009,
	"./HR.svg": 72199,
	"./HT.svg": 61544,
	"./HU.svg": 25761,
	"./ID.svg": 84580,
	"./IE.svg": 59372,
	"./IL.svg": 31272,
	"./IM.svg": 53539,
	"./IN.svg": 14685,
	"./IO.svg": 38911,
	"./IQ.svg": 73914,
	"./IR.svg": 94950,
	"./IS.svg": 87410,
	"./IT.svg": 42151,
	"./JE.svg": 80996,
	"./JM.svg": 9238,
	"./JO.svg": 19768,
	"./JP.svg": 90229,
	"./KE.svg": 41757,
	"./KG.svg": 93329,
	"./KH.svg": 49217,
	"./KI.svg": 82109,
	"./KM.svg": 72099,
	"./KN.svg": 1663,
	"./KP.svg": 18239,
	"./KR.svg": 31681,
	"./KW.svg": 46739,
	"./KY.svg": 45397,
	"./KZ.svg": 15583,
	"./LA.svg": 48089,
	"./LB.svg": 84550,
	"./LC.svg": 24920,
	"./LI.svg": 64394,
	"./LK.svg": 44790,
	"./LR.svg": 1354,
	"./LS.svg": 45944,
	"./LT.svg": 28053,
	"./LU.svg": 3362,
	"./LV.svg": 77485,
	"./LY.svg": 52661,
	"./MA.svg": 5042,
	"./MC.svg": 11822,
	"./MD.svg": 32275,
	"./ME.svg": 81150,
	"./MF.svg": 36959,
	"./MG.svg": 16756,
	"./MH.svg": 71386,
	"./MK.svg": 97492,
	"./ML.svg": 16589,
	"./MM.svg": 75019,
	"./MN.svg": 87005,
	"./MO.svg": 62718,
	"./MP.svg": 20094,
	"./MQ.svg": 14748,
	"./MR.svg": 48577,
	"./MS.svg": 95436,
	"./MT.svg": 60559,
	"./MU.svg": 44557,
	"./MV.svg": 83822,
	"./MW.svg": 26654,
	"./MX.svg": 95881,
	"./MY.svg": 9625,
	"./MZ.svg": 14037,
	"./NA.svg": 52508,
	"./NC.svg": 52953,
	"./NE.svg": 12098,
	"./NF.svg": 26640,
	"./NG.svg": 18050,
	"./NI.svg": 29406,
	"./NL.svg": 60296,
	"./NO.svg": 23903,
	"./NP.svg": 90609,
	"./NR.svg": 72451,
	"./NU.svg": 96914,
	"./NZ.svg": 75925,
	"./OM.svg": 36119,
	"./PA.svg": 98088,
	"./PE.svg": 27795,
	"./PF.svg": 28450,
	"./PG.svg": 62996,
	"./PH.svg": 95379,
	"./PK.svg": 7166,
	"./PL.svg": 73538,
	"./PM.svg": 25847,
	"./PN.svg": 15276,
	"./PR.svg": 36646,
	"./PS.svg": 68750,
	"./PT.svg": 79911,
	"./PW.svg": 1363,
	"./PY.svg": 18928,
	"./QA.svg": 77843,
	"./RE.svg": 49554,
	"./RO.svg": 32492,
	"./RS.svg": 15942,
	"./RU.svg": 22834,
	"./RW.svg": 38258,
	"./SA.svg": 68590,
	"./SAMI.svg": 80193,
	"./SB.svg": 55263,
	"./SC.svg": 48849,
	"./SD.svg": 79969,
	"./SE-JAM.svg": 78769,
	"./SE-SKA.svg": 56916,
	"./SE-VAS.svg": 24861,
	"./SE.svg": 74233,
	"./SEFI.svg": 10558,
	"./SG.svg": 62722,
	"./SH.svg": 22882,
	"./SI.svg": 61699,
	"./SJ.svg": 30449,
	"./SK.svg": 97303,
	"./SL.svg": 59591,
	"./SM.svg": 97283,
	"./SN.svg": 20177,
	"./SO.svg": 27831,
	"./SR.svg": 67566,
	"./SS.svg": 46153,
	"./ST.svg": 42519,
	"./SV.svg": 11714,
	"./SX.svg": 1089,
	"./SY.svg": 19221,
	"./SZ.svg": 57811,
	"./TC.svg": 86715,
	"./TD.svg": 93346,
	"./TF.svg": 55804,
	"./TG.svg": 71148,
	"./TH.svg": 65621,
	"./TJ.svg": 4913,
	"./TK.svg": 85711,
	"./TL.svg": 44050,
	"./TM.svg": 47135,
	"./TN.svg": 46138,
	"./TO.svg": 20195,
	"./TORN.svg": 86902,
	"./TR.svg": 59210,
	"./TT.svg": 8102,
	"./TV.svg": 577,
	"./TW.svg": 5232,
	"./TZ.svg": 5409,
	"./UA.svg": 41451,
	"./UG.svg": 32456,
	"./UM.svg": 13684,
	"./US-CA.svg": 29321,
	"./US.svg": 91706,
	"./UY.svg": 94848,
	"./UZ.svg": 20671,
	"./VA.svg": 49278,
	"./VC.svg": 11783,
	"./VE.svg": 57141,
	"./VG.svg": 92518,
	"./VI.svg": 97654,
	"./VN.svg": 68226,
	"./VU.svg": 82902,
	"./WF.svg": 58101,
	"./WORLD.svg": 67926,
	"./WS.svg": 11060,
	"./WW-AFR.svg": 99763,
	"./WW-ASI.svg": 7289,
	"./WW-AUS.svg": 24715,
	"./WW-EUR.svg": 37636,
	"./WW-NAM.svg": 10753,
	"./WW-SAM.svg": 77420,
	"./WW.svg": 91590,
	"./XK.svg": 69453,
	"./YE.svg": 23367,
	"./YT.svg": 88111,
	"./ZA.svg": 62611,
	"./ZM.svg": 10967,
	"./ZW.svg": 1843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89997;